import {
  GetAvailableRegionsInCountryRequest,
  GetCitiesInCountryRequest,
  GetCitizenshipsRequest,
  GetCitizenshipsResponseDto,
} from '@/api/generated/fetch-client';
import { RepositoryException, WithSignal } from '@/types/typings';

import { CountryApi } from '../../api';
import { CityList } from '../../types/city-list';
import { RegionList } from '../../types/region-list';

export class GeoRepository {
  constructor(private readonly countryApi: CountryApi) {}

  public async getCities(
    requestParams: WithSignal<GetCitiesInCountryRequest>,
  ): Promise<CityList> {
    const response = await this.countryApi.findCitiesByCountryCode(requestParams);

    if (!response) {
      throw new RepositoryException('repository getCities error');
    }
    return CityList.fromDto(response);
  }

  public async getCountries(
    requestParams: WithSignal<GetCitizenshipsRequest>,
  ): Promise<GetCitizenshipsResponseDto> {
    const response = await this.countryApi.findCountries(requestParams);

    if (!response) {
      throw new RepositoryException('repository getCountries error');
    }

    return response;
  }

  public async getRegions(
    requestParams: WithSignal<GetAvailableRegionsInCountryRequest>,
  ): Promise<RegionList> {
    const response = await this.countryApi.findRegionsByCountryCode(requestParams);

    if (!response) {
      throw new RepositoryException('repository getRegions error');
    }
    return RegionList.fromDto(response);
  }
}
